import { useRef, useState } from "react";
import { CONTACT_EMAIL } from "@/lib/brand";

/**
 * Versand der Formulare über die PHP-Skripte in public/api (bei STRATO).
 * Lokal leitet der Entwicklungsserver /api an einen PHP-Server auf Port 8000
 * weiter („proxy“ in package.json, siehe README).
 */
const api = (file) => `${process.env.PUBLIC_URL}/api/${file}`;
export const API_CONTACT = api("kontakt.php");
export const API_WAITLIST = api("warteliste.php");
export const API_CONFIRM = api("bestaetigen.php");

/** Schickt Daten als JSON. Liefert { ok: true } oder { ok: false, error, fields }. */
export async function postJson(url, data) {
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data),
    });
    const json = await res.json().catch(() => ({}));
    if (res.ok && json.ok) return { ok: true };
    return { ok: false, error: json.error || "versand", fields: json.fields || [] };
  } catch {
    return { ok: false, error: "netz", fields: [] };
  }
}

/**
 * Spamschutz ohne Captcha: misst, wie lange das Formular offen ist, und hält
 * das versteckte Feld „website“, das nur Bots ausfüllen. Die Skripte werten
 * beides aus (public/api/lib.php, mg_guard).
 */
export function useSpamGuard() {
  const openedAt = useRef(Date.now());
  const [website, setWebsite] = useState("");
  return {
    honeypot: { value: website, onChange: setWebsite },
    fields: () => ({ website, elapsed: Date.now() - openedAt.current }),
    reset: () => {
      openedAt.current = Date.now();
      setWebsite("");
    },
  };
}

/**
 * Holt ein Element nach dem Absenden ins Bild, wenn es außerhalb liegt. Die
 * Bestätigung ist kürzer als das Formular, sonst stünde sie oberhalb des
 * sichtbaren Bereichs. Läuft über einen Ankerklick, damit Lenis sanft
 * scrollt (src/hooks/useLenis.js); das Element braucht dafür eine id.
 */
export function revealElement(element) {
  if (!element?.id) return;
  const { top } = element.getBoundingClientRect();
  if (top > 140 && top < window.innerHeight * 0.6) return;
  const anchor = document.createElement("a");
  anchor.href = `#${element.id}`;
  anchor.hidden = true;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}

/**
 * Verständliche Meldung zum Fehler eines Skripts. `labels` ordnet den
 * Feldnamen ihre Beschriftung zu, damit klar ist, was nicht passt.
 */
export function formErrorMessage({ error, fields = [] }, labels = {}) {
  if (error === "ungueltig") {
    const named = fields.map((f) => labels[f]).filter(Boolean);
    return named.length
      ? `Bitte prüft eure Angaben: ${named.join(", ")}.`
      : "Bitte prüft eure Angaben, etwas passt noch nicht.";
  }
  if (error === "netz") {
    return "Keine Verbindung. Bitte prüft eure Internetverbindung und versucht es noch einmal.";
  }
  return `Das hat leider nicht geklappt. Bitte versucht es gleich noch einmal oder schreibt uns direkt an ${CONTACT_EMAIL}.`;
}
